export const BASEPATH = window.location.origin;
export const BASKETPATH = (typeof basketPath !== 'undefined') ? basketPath : BASEPATH;
export const CHECKOUTPATH = (typeof checkoutPath !== 'undefined') ? checkoutPath : BASEPATH;

export const ALERT_SUCCESS_CLASS = 'msg-box-success';
export const ALERT_ERROR_CLASS = 'msg-box-error';
export const ALERT_CLASS = 'msg-box';
export const HIDE_ELEMENT_CLASS = 'hide';

export const ELEMENT_HAS_ERROR_CLASS = 'has-error';
export const ELEMENT_ERROR_BLOCK_SELECTOR = '.help-block';

export const SPINNER_ACTIVE = 'spinner-active';

export const VALID_CLASS = 'is-valid';
export const INVALID_CLASS = 'is-invalid';
export const FIELD_CLASS = 'form-control';

export const RADIO_BUTTON_SELECTOR = '[data-radio-selection]';
